import { ProfressionalSubscriptionModel } from '../../models/subscription/professional-subscription.model';
import { SubscriptionPlanModel } from '../../models/subscription/subscription-plan.model';

export class SubscriptionStateModel {
  buying: boolean;
  updating: boolean;
  cancelling: boolean;
  checkingCode: boolean;
  // avialble plans for checkout
  plans: SubscriptionPlanModel[];
  selectedPlan?: SubscriptionPlanModel;
}
